import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import { getAttributionPayload } from "../lib/attribution";
import { fireConversion, setEnhancedConversionData } from "../lib/tracking";
import { trackEvent } from "../lib/trackingClient";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Formular() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "", phone: "", email: "", gewerk: "", region_plz: "", message: "",
  });
  const [consent, setConsent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!consent) return setError("Bitte stimmen Sie der Datenverarbeitung zu.");
    if (!form.name || !form.phone) return setError("Name und Telefon sind erforderlich.");
    setLoading(true);
    try {
      await axios.post(`${API}/leads`, {
        ...form,
        consent: true,
        source: "formular",
        attribution: getAttributionPayload(),
      });
      await setEnhancedConversionData({ email: form.email, phone: form.phone });
      fireConversion("lead_formular");
      trackEvent("lead_formular", { value: 80 });
      navigate("/danke");
    } catch (err) {
      setError(err.response?.data?.detail || "Es ist ein Fehler aufgetreten.");
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full rounded-md border border-white/10 bg-[#0E0F12] px-3 py-2.5 text-sm text-white placeholder:text-gray-500 focus:border-[#3DDC97] focus:outline-none";

  return (
    <div className="min-h-screen bg-[#0E0F12] px-6 py-16">
      <div className="mx-auto max-w-lg">
        <Link to="/" className="mb-8 inline-flex items-center gap-2 text-sm text-gray-400 hover:text-[#3DDC97]">
          <ArrowLeft size={16} /> Zurück
        </Link>
        <h1 className="font-display text-3xl font-bold text-white">Kostenlose Kurzanalyse anfragen</h1>
        <p className="mt-3 text-[15px] text-gray-400">
          Wir melden uns zeitnah mit einer ehrlichen Einschätzung für Ihren Betrieb.
        </p>
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="lead-form">
          <input data-testid="form-name" className={field} placeholder="Ihr Name *" value={form.name} onChange={set("name")} />
          <input data-testid="form-phone" className={field} placeholder="Telefonnummer *" value={form.phone} onChange={set("phone")} />
          <input data-testid="form-email" className={field} placeholder="E-Mail (optional)" value={form.email} onChange={set("email")} />
          <input data-testid="form-gewerk" className={field} placeholder="Dienstleistung / Branche" value={form.gewerk} onChange={set("gewerk")} />
          <input data-testid="form-plz" className={field} placeholder="Region / PLZ" value={form.region_plz} onChange={set("region_plz")} />
          <textarea data-testid="form-message" className={field} rows={3} placeholder="Worum geht es? (optional)" value={form.message} onChange={set("message")} />
          <label className="flex items-start gap-2 text-sm text-gray-400">
            <input data-testid="form-consent" type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-1 accent-[#3DDC97]" />
            <span>
              Ich bin mit der Verarbeitung meiner Daten zur Kontaktaufnahme einverstanden.
              {" "}<Link to="/datenschutz" className="text-[#3DDC97] underline">Datenschutz</Link>.
            </span>
          </label>
          {error && <p data-testid="form-error" className="text-sm text-red-400">{error}</p>}
          <button
            data-testid="form-submit"
            type="submit"
            disabled={loading}
            className="w-full rounded-md bg-[#3DDC97] py-3.5 font-semibold text-[#0E0F12] transition-colors hover:bg-[#2BBF7E] disabled:opacity-50"
          >
            {loading ? "Wird gesendet …" : "Anfrage absenden"}
          </button>
        </form>
      </div>
    </div>
  );
}
